// extracted by mini-css-extract-plugin
export var quantityInput = "_is-0";